// Kohteet-listasta kartalle valittu reitti tai kohde: pieni palkki kartan alareunassa.
// Reitin linja on jo korostettuna kartalla (MapView, selectedRoute); palkista pääsee reitin korttiin
// (kuvaus, pisteet, merkitseminen suoritetuksi) tai sulkemaan valinnan. Kohteella korostuvat merkki ja tunnistusalue.

import { routeFacts } from "../lib/routeInfo.js";

export function RouteBar({ app }) {
  const route = app.mapRoute ? app.content?.routes?.find((r) => r.id === app.mapRoute) : null;
  if (!route) return null;
  const done = route.state.done;
  const progress = !done && route.progress_estimate != null ? Math.round(route.progress_estimate * 100) : null;
  // Palkin toinen rivi: pituus ja vaativuus, sitten tila.
  const facts = [routeFacts(route), done ? "Suoritettu" : progress ? `Kuljettu arviolta ${progress} %` : "Ei vielä suoritettu"].filter(Boolean).join(" · ");

  return (
    <section class="route-bar" aria-label="Valittu reitti">
      <div class="route-bar-head">
        <div class="route-bar-title">
          <b>{route.name}</b>
          <span>{facts}</span>
        </div>
        <b class="route-bar-pts num">{route.points}<small> p</small></b>
      </div>
      {progress != null && <div class="meter"><i style={{ width: `${progress}%` }} /></div>}
      <div class="route-bar-foot">
        <button class="btn btn-rasti" onClick={() => app.openContent("route", route.id)}>Tiedot</button>
        <button class="btn" onClick={app.clearMapRoute}>Sulje</button>
      </div>
    </section>
  );
}

const CATEGORY = { luonto: "Luonto", historia: "Historia", arkkitehtuuri: "Arkkitehtuuri", nakoala: "Näköala", taukopaikka: "Taukopaikka", muu: "Muu" };

/** Kartalle valitun kohteen palkki: nimi, tyyppi ja tila sekä Tiedot ja Sulje. */
export function PoiBar({ app }) {
  const poi = app.mapPoi ? app.content?.pois?.find((p) => p.id === app.mapPoi) : null;
  if (!poi) return null;
  const facts = [poi.area === poi.municipality ? poi.area : `${poi.area}, ${poi.municipality}`, CATEGORY[poi.category], poi.state.done ? "Käyty" : "Ei vielä käyty"].filter(Boolean).join(" · ");

  return (
    <section class="route-bar" aria-label="Valittu kohde">
      <div class="route-bar-head">
        <div class="route-bar-title">
          <b>{poi.name}</b>
          <span>{facts}</span>
        </div>
        <b class="route-bar-pts num">{poi.points}<small> p</small></b>
      </div>
      <p class="s route-bar-hint">Käynti tunnistuu, kun kuljet {Math.round(poi.visit_radius_m || 40)} m:n säteelle merkistä (sininen alue).</p>
      <div class="route-bar-foot">
        <button class="btn btn-rasti" onClick={() => app.openContent("poi", poi.id)}>Tiedot</button>
        {/* Pisteen siirto suoraan palkista: paikan päällä GPS:llä ("Käytä sijaintiani") tai tähtäimellä. */}
        {app.admin && (
          <button
            class="btn"
            onClick={() => app.startTool({ type: "poi", id: poi.id, name: poi.name, radius: poi.visit_radius_m, start: poi.has_location ? [poi.lat, poi.lon] : null })}
          >
            Siirrä pistettä
          </button>
        )}
        <button class="btn" onClick={app.clearMapPoi}>Sulje</button>
      </div>
    </section>
  );
}
